/* oxlint-disable no-console */
import { enableProdMode, provideZoneChangeDetection } from "@angular/core";

import { bootstrapApplication } from "@angular/platform-browser";

import { AppComponent } from "./app/app.component";
import { appBrowserConfig } from "./app/app.config.browser";

import { environment } from "./environments/environment";

if (environment.production) {
    enableProdMode();
}

const bootstrap = () => {
    bootstrapApplication(AppComponent, {...appBrowserConfig, providers: [provideZoneChangeDetection(), ...appBrowserConfig.providers]}).catch((error) =>
        console.error(error),
    );
};

if (document.readyState === "complete") {
    bootstrap();
} else {
    document.addEventListener("DOMContentLoaded", bootstrap);
}
